import { ControlPointSharp } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";

const token = localStorage.getItem("wdtoken");
const user = localStorage.getItem("user");
const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: token || "",
    user: user || "",
  },
  reducers: {
    login(state, action) {
     
     
      state.token = action.payload.token;
      state.user = action.payload.admin;
    },
    logout(state) {
      state.token = "";
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
